export default "__VITE_ASSET__T49T2xLQ__"